const errorReporter = store => next => action => {
  if (action.error) {
    window.rg4js('send', new Error(action.payload))
  }

  return next(action)
}

export default errorReporter



// WEBPACK FOOTER //
// ./src/redux/store/middleware/error-reporter.js